<template>
  <form @submit.prevent="submitted">
    <label>
      Category name
      <input v-model="category.label" type="text" />
    </label>

    <label>
      Weighting (default: 1)<br />
      <small
        >Used when categorising a users message to increase or decrease the chance of this category being
        selected.</small
      >
      <input v-model="category.weighting" type="number" step="0.01" />
    </label>

    <label>
      Keywords (seperated with commas)
      <textarea ref="keywords" v-model="category.keywords"></textarea>
    </label>

    <label>
      Negative Keywords (seperated with commas)
      <small>If a negative keyword is matched, category will be ignored.</small>
      <textarea ref="negative_keywords" v-model="category.negative_keywords"></textarea>
    </label>

    <label>Parent category</label>
    <select v-model="category.parent_id">
      <option value="">-</option>
      <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.label }}</option>
    </select>

    <label>Initial Query</label>
    <select v-model="category.query_id">
      <option value="">-</option>
      <option v-for="query in queries" :key="query.id" :value="query.id">{{ query.label }}</option>
    </select>

    <label>
      Max Consecutive Queries
      <input v-model="category.max_consecutive" type="number" />
    </label>

    <label class="input -checkbox">
      <input v-model="category.fallback" type="checkbox" />
      Use as fallback category
    </label>

    <label class="input -checkbox">
      <input v-model="category.contains_time" type="checkbox" />
      Use as contains time category
    </label>

    <action-button class="-mt" :text="buttonText" :state="state" @pressed="submitted"></action-button>
  </form>
</template>

<script>
import autosize from "autosize";
import { mapState } from "vuex";

import actionButton from "@/components/actionButton";

export default {
  components: { actionButton },

  props: {
    category: {
      type: Object,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Create Category"
    }
  },

  computed: {
    ...mapState({
      categories: (state) => state.categories.all,
      queries: (state) => state.queries.all
    })
  },

  mounted() {
    autosize(this.$refs.keywords);
    autosize(this.$refs.negative_keywords);
  },

  methods: {
    submitted() {
      this.$emit("submitted");
    }
  }
};
</script>
